(() => {
  if (customElements.get('torras-preorder-countdown')) return;
  const DAY = 86400000;
  const SINGAPORE_OFFSET = 8 * 3600000;

  customElements.define('torras-preorder-countdown', class extends HTMLElement {
    connectedCallback() {
      const date = this.dataset.endDate;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return;
      this.endDay = Date.parse(`${date}T00:00:00Z`) / DAY;
      if (!Number.isInteger(this.endDay)) return;
      this.refresh = () => this.update();
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('focus', this.refresh);
      this.update();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('focus', this.refresh);
    }

    update() {
      clearTimeout(this.timer);
      // Compare calendar dates in Singapore; a visitor's timezone never changes the count.
      const singaporeNow = Date.now() + SINGAPORE_OFFSET;
      const days = this.endDay - Math.floor(singaporeNow / DAY);
      this.hidden = days <= 0;
      if (this.hidden) return;
      const copy = days === 1 ? this.dataset.copyOne : this.dataset.copyOther;
      const [before, after] = copy.split('__DAYS__');
      const number = document.createElement('strong');
      number.className = 'torras-preorder-countdown__number';
      number.textContent = String(days);
      this.querySelector('[data-preorder-days]').replaceChildren(
        document.createTextNode(before), number, document.createTextNode(after || '')
      );
      this.timer = setTimeout(this.refresh, DAY - (singaporeNow % DAY) + 50);
    }
  });
})();
